import React from "react";
import { AbsoluteFill, Series } from "remotion";
import { Intro } from "./scenes/intro";
import { MapScene } from "./scenes/map-scene";
import type { TripData, VideoConfig } from "../types";
import { INTRO_FRAMES, OUTRO_FRAMES, VIDEO_FPS } from "../types";

export interface TripVideoProps {
    tripData: TripData;
    config: VideoConfig;
    mapboxToken: string;
    isExporting?: boolean;
}

export function mapFrameCount(
    _tripData: TripData,
    config: VideoConfig,
): number {
    // Total duration minus 3s intro and 3s outro
    const mapDurationSeconds = Math.max(
        1,
        config.targetDurationSeconds -
            (INTRO_FRAMES + OUTRO_FRAMES) / VIDEO_FPS,
    );
    return Math.max(1, Math.round(mapDurationSeconds * VIDEO_FPS));
}

export const TripVideo: React.FC<TripVideoProps> = ({
    tripData,
    config,
    mapboxToken,
}) => {
    const mapFrames = mapFrameCount(tripData, config);
    const dateLabel =
        tripData.dateLabel ??
        new Date(tripData.startTime).toLocaleDateString("en-AU", {
            month: "long",
            year: "numeric",
        });

    return (
        <AbsoluteFill>
            <Series>
                <Series.Sequence durationInFrames={INTRO_FRAMES}>
                    <Intro
                        title={tripData.title}
                        subtitle={tripData.subtitle}
                        dateLabel={dateLabel}
                        watermarkImage={tripData.watermarkImage}
                        boatPhoto={tripData.boatPhoto}
                    />
                </Series.Sequence>
                <Series.Sequence durationInFrames={mapFrames + OUTRO_FRAMES}>
                    <MapScene
                        tripData={tripData}
                        mapboxToken={mapboxToken}
                        cameraMode={config.cameraMode}
                        terrainEnabled={config.terrainEnabled}
                        outroFrames={OUTRO_FRAMES}
                        title={tripData.title}
                        totalDistanceM={tripData.totalDistanceM}
                        avgSpeedMps={tripData.avgSpeedMps}
                        distanceUnit={tripData.distanceUnit}
                        speedUnit={tripData.speedUnit}
                        underwayDurationSeconds={
                            tripData.underwayDurationSeconds
                        }
                        watermarkImage={tripData.watermarkImage}
                    />
                </Series.Sequence>
            </Series>
        </AbsoluteFill>
    );
};
